import * as React from 'react';
import * as formUtils from '../../utils/form-utils';
import FormItem from 'antd/lib/form/FormItem';

interface ErrorFormItemProps {
  message: React.ReactNode;
}

class ErrorFormItem extends React.Component<ErrorFormItemProps, {}> {

  public render(): React.ReactNode {
    const {message} = this.props;
    return (
      <FormItem className="has-error" {...formUtils.tailFormItemLayout}>
        <div className="ant-form-explain">{message}</div>
      </FormItem>
    );
  }
}

export default ErrorFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/ErrorFormItem.tsx